import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

const baseURL = `https://nisia.jfrn.jus.br/webhooks/rest/webhook`;
const baseURLChatGPT = `https://nisia-backend.jfrn.jus.br/chatbot/`;

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  tokenConversa: any
  chatObserver = new Subject<any>();
  dadosRespostaMsg: any;
  evento!: IEvento;
  respConversa: any

  constructor(private http: HttpClient) { }

  getChatObserver(): Observable<any> {
    return this.chatObserver.asObservable();
  }

  closeChat() {
    this.evento = { nomeEvento: "fechar", mensagensRobo: null, mensagemAnterior: "" }
    this.chatObserver.next(this.evento);
  }

  hideChat() {
    this.evento = { nomeEvento: "ocultar", mensagensRobo: null, mensagemAnterior: "" }
    this.chatObserver.next(this.evento);
  }

  openChat() {
    this.evento = { nomeEvento: "abrir", mensagensRobo: this.dadosRespostaMsg, mensagemAnterior: "" }
    this.chatObserver.next(this.evento);
  }

  notificaNovaMsg(msg: any, msgAnterior: any) {
    this.evento = { nomeEvento: "novaMsg", mensagensRobo: msg, mensagemAnterior: msgAnterior }
    this.chatObserver.next(this.evento);
  }

  notificaNovaMsgGtp(msg: any, msgAnterior: any) {
    this.evento = { nomeEvento: "novaMsgGpt", mensagensRobo: msg, mensagemAnterior: msgAnterior }
    this.chatObserver.next(this.evento);
  }

  notificaMsgInicialRobo(msg: any) {
    this.evento = { nomeEvento: "msgInicial", mensagensRobo: msg, mensagemAnterior: "" }
    this.chatObserver.next(this.evento);
  }

  enviarMensagem(mensagem: string) {
    const data = {
      "sender": "Usuário",
      "message": mensagem,
    };

    this.http.post(`${baseURL}`, data).subscribe(
      (resp: any) => {
       if (Array.isArray(resp) && resp.length != 0) {
          console.log("chamou resp array", resp);
          resp.forEach((message) => {
            this.notificaNovaMsg(message, "");
            console.log(message);
          });
        } else if (resp.length != 0) {
          console.log("chamou resp normal", resp);
          this.notificaNovaMsg(resp, "");
          console.log(resp);
        }else{
          console.log("chamou gpt");
          let retorno = this.getChatGpt(mensagem);
          //console.log("retorno", retorno);
          //this.notificaNovaMsgGtp(retorno, "");
        }
      },
      (err) => { }
    );
  }

  getChatGpt(mensagem: any) {
    console.log("chamou GPT");

    const data = {
      "message": mensagem,
    };

    const cabecalho = {
        headers: new HttpHeaders({
            'Content-Type': 'multipart/form-data'
        })
    };

    this.http.post(`${baseURLChatGPT}`, data, cabecalho)
      .subscribe(
        (resp: any) => {
          // Se a resposta for um JSON, você pode acessar os dados diretamente
          this.respConversa = resp;
          console.log("Resposta", resp);
          //return resp;
          this.notificaNovaMsgGtp(resp, "");
        },
        err => {
          console.log("Error", err);
          // Lide com o erro aqui, se necessário
        }
      )

      //return "";
  }


  criarConversa(dados: any) {
    console.log("criou a conversa v.1.10");

    const data =
    {
      "sender": dados.nome,
      "message": dados.message,
    }

    return this.http.post(`${baseURL}`, data)
      .subscribe(
        (resp: any) => {
          this.respConversa = resp[0]
          console.log("Resposta", resp[0]);
          this.notificaMsgInicialRobo(resp[0]);
        },
        err => {console.log("Error"); }
      )
  }

}

export interface IDivida {
  possuiOportunidades: boolean;
  total : string;
}

interface IEvento {
  nomeEvento: string;
  mensagensRobo: any;
  mensagemAnterior : any;
}

interface IMensagem {
  CriaConversa: string;
  Token: string;
  NomeUsuario: number;
  CpfUsuario: number;
  TelefoneUsuario: number;
  EmailUsuario: number;
}
